import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ImageActions, MapActions } from "../../_actions";
import { useModal, useApp, useMaps } from "../../_contexts";
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { DevTool } from "@hookform/devtools";
import { toast } from "react-toastify";
import { useEventListener } from "../../_hooks";

import {
  Button,
  Tabs,
  Icon,
  FileDropzone,
  Toggle,
  ImagePicker,
  PaneLoader,
  FormError,
  ZoomControlsField,
} from "../../_components";
import ReactTooltip from "react-tooltip";

const MAX_FILESIZE_MB = 30;

export function NewMapForm(props) {
  const { mapData, prevModal, prevForm } = props;
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { details: world } = useSelector((state) => state.world);
  const { items: images } = useSelector((state) => state.images);
  const { closeModal, openModal } = useModal();
  const [isLoading, setLoading] = useState(false);
  const { user } = useApp();
  const { setCurrentMap, currentMap } = useMaps();

  const dispatch = useDispatch();

  const existingID =
    mapData && mapData.image
      ? typeof mapData.image === "string"
        ? mapData.image
        : mapData.image._id
        ? mapData.image._id
        : ""
      : "";
  // ? mapData.image && typeof mapData.image === "string"
  //   ? mapData.image && mapData.image._id
  //     ? mapData.image._id
  //     : mapData.image
  //   : "image or id"
  // : "map data";

  const {
    handleSubmit,
    control,
    setError,
    errors,
    watch,
    setValue,
    formState,
  } = useForm({
    mode: "all",
    defaultValues: {
      //Basic
      title: mapData ? mapData.title : "",
      description: mapData ? mapData.description : "",
      attribution: mapData ? mapData.attribution : "",
      attributionLink: mapData ? mapData.attributionLink : "",
      // data: mapData ? mapData.image.url : '',
      image: {
        new: [],
        existing: existingID,

        // existing: mapData
        //   ? mapData.image && typeof mapData.image === "string"
        //     ? mapData.image
        //     : mapData.image?._id || ""
        //   : "",
      },
      options: {
        zoomMin: mapData && mapData.options ? mapData.options.zoomMin : -3,
        zoomMax: mapData && mapData.options ? mapData.options.zoomMax : 3,
        zoomDefault:
          mapData && mapData.options ? mapData.options.zoomDefault : 0,
        coordX: mapData && mapData.options ? mapData.options.coordX : 0,
        coordY: mapData && mapData.options ? mapData.options.coordY : 0,
        showAttribution:
          mapData && mapData.options ? mapData.options.showAttribution : true,
        showZoom: mapData && mapData.options ? mapData.options.showZoom : true,
        customClass:
          mapData && mapData.options ? mapData.options.customClass : "",
      },
    },
    shouldUnregister: false,
  });

  const handleSelectExistingImage = (onChange, value) => {
    // console.log("Selecting existing image!", value);
    onChange(value);
    setValue("image.new", []);
  };

  const handleSelectNewImage = (onChange, value) => {
    // console.log("Selecting New Image!", value);
    onChange(value);
    setValue("image.existing", "");
  };

  const onSubmit = (formData) => {
    setLoading(true);
    console.log(formData);
    //Validate Image
    if (formData.image) {
      if (formData.image.new.length === 0) {
        if (formData.image.existing && formData.image.existing.length === 0) {
          let message =
            "You must select either a new or existing image for this Map.";
          toast.error(message, { autoClose: 5000 });
          // setError('image.new', {
          //   message,
          // });
          setLoading(false);
          return;
        }
        const image = images.find((i) => i._id === formData.image.existing);
        if (!image) {
          let message =
            "You must select either a new or existing image for this Map.";
          toast.error(message, { autoClose: 5000 });
          // setError('image.new', {
          //   message,
          // });
          setLoading(false);
          return;
        }
      }
      // } else {
      //   let message =
      //     'You must select either a new or existing image for this Map.';
      //   toast.error(message, { autoClose: 5000 });
      //   setError('image.new', {
      //     message,
      //   });
      //   setLoading(false);
    }

    //First, clean the custom css class option
    const customClassName = formData.options.customClass.replace(/\s/gim, "_");
    //Set default Map properties
    const mapOptions = {
      zoomMin: parseFloat(formData.options.zoomMin),
      zoomMax: parseFloat(formData.options.zoomMax),
      zoomDefault: parseFloat(formData.options.zoomDefault),
      coordX: parseFloat(formData.options.coordX),
      coordY: parseFloat(formData.options.coordY),
      showAttribution: formData.options.showAttribution,
      showZoom: formData.options.showZoom,
      customClass: customClassName,
    };

    // Create a new Map object
    const newMap = {
      ...formData,
      options: mapOptions,
      chronicle: chronicle._id,
      world: world._id,
    };

    if (formData.image.new && formData.image.new.length === 1) {
      //Upload Image First, then update map with image ID
      //First, create a new FormData object for the image
      let newImage = new FormData();
      newImage.append("name", formData.title);
      newImage.append("imageType", "map");
      newImage.append("world", world._id);
      newImage.append("chronicle", chronicle._id);
      newImage.append("waUser", user.userID);
      //If the image has a preview property, we need to remove it to
      //prevent the data from the image being uploaded twice. Not a
      //huge issue, just done to conserve bandwidth and make the upload
      //faster.
      if (formData.image.new[0].preview) {
        delete formData.image.new[0].preview;
      }
      //Append the image file to the FormData
      newImage.append("images", formData.image.new[0]);

      //Upload the image
      dispatch(ImageActions.upload(newImage)).then((results) => {
        //We successfully got the image uploaded. Now we have to
        //update the new Map object with the result's _id
        newMap.image = results[0]._id;

        //Next, we need to check if we're updating an existing Map
        // or creating a new Map
        if (mapData && mapData._id) {
          //Editing an existing Map
          dispatch(MapActions.updateMap(mapData._id, newMap)).then((result) => {
            setLoading(false);
            //The map update has completed successfully
            if (result) {
              console.group("--------");
              console.warn("MAP CHANGING");
              console.log("MAP:", mapData);
              console.log("Existing Map", currentMap);
              if (currentMap && mapData._id === currentMap._id) {
                console.log("Updating map!");
                setCurrentMap(result);
              }
              console.groupEnd();
              //Check if we were led here from a previous modal
              //MapManager, most likely, and return to it. Else,
              //we're done, so close the modal interface.
              if (prevModal && prevModal.length > 0) {
                if (prevForm) {
                  openModal(prevModal, { prevForm });
                } else {
                  openModal(prevModal);
                }
              } else {
                closeModal();
              }
            }
          });
        } else {
          //Uploading a new Map
          dispatch(MapActions.createNewMap(newMap)).then((result) => {
            setLoading(false);
            //The map creation has completed successfully
            if (result) {
              setCurrentMap(result);
              //Check if we were led here from a previous modal
              //MapManager, most likely, and return to it. Else,
              //we're done, so close the modal interface.
              if (prevModal && prevModal.length > 0) {
                if (prevForm) {
                  openModal(prevModal, { prevForm });
                } else {
                  openModal(prevModal);
                }
              } else {
                closeModal();
              }
            }
          });
        }
      });
    } else {
      //We're changing the Image, not uploading. We need to ensure
      //an image is selected
      if (formData.image.existing && formData.image.existing.length > 0) {
        //Simply swapping the image
        newMap.image = formData.image.existing;
      } else {
        newMap.image = null;
      }

      //We need to check if we're updating a map or creating a new one
      if (mapData && mapData._id) {
        //Updating an existing Map
        dispatch(MapActions.updateMap(mapData._id, newMap)).then((result) => {
          setLoading(false);
          //The map update has completed successfully
          if (result) {
            console.group("--------");
            console.warn("MAP CHANGING");
            console.log("MAP:", { ...mapData });
            console.log("Existing Map", { ...currentMap });
            console.log("Result", { ...result });
            if (currentMap && mapData._id === currentMap._id) {
              console.log("Updating map!");
              setCurrentMap(result);
            }
            console.groupEnd();
            //Check if we were led here from a previous modal
            //MapManager, most likely, and return to it. Else,
            //we're done, so close the modal interface.
            if (prevModal && prevModal.length > 0) {
              if (prevForm) {
                openModal(prevModal, { prevForm });
              } else {
                openModal(prevModal);
              }
            } else {
              closeModal();
            }
          }
        });
      } else {
        //Creating a new map
        dispatch(MapActions.createNewMap(newMap)).then((result) => {
          setLoading(false);
          if (result) {
            //Check if we were led here from a previous modal
            //MapManager, most likely, and return to it. Else,
            //we're done, so close the modal interface.
            if (prevModal && prevModal.length > 0) {
              if (prevForm) {
                openModal(prevModal, { prevForm });
              } else {
                openModal(prevModal);
              }
            } else {
              closeModal();
            }
          }
        });
      }
    }
    return;
  };

  const handleCancel = (ev) => {
    setLoading(false);
    if (prevModal && prevModal.length > 0) {
      if (prevForm) {
        openModal(prevModal, { prevForm });
      } else {
        openModal(prevModal);
      }
    } else {
      closeModal();
    }
  };

  const { isValidating, isSubmitting, dirtyFields, touched } = formState;

  const handleKeyClose = (ev) => {
    // console.log("Key up: ", ev);
    if (ev.key && ev.key.toLowerCase() === "escape") {
      console.log("Form State: ", { ...formState });
      if (!isValidating && !isSubmitting) {
        if (
          // formState.dirtyFields &&
          Object.keys(dirtyFields).length === 0 &&
          // formState.touched &&
          Object.keys(touched).length === 0
        ) {
          // console.log("dirty fields!");
          handleCancel();
        }
      }
    }
  };

  useEventListener("keyup", handleKeyClose);

  const defaultImageTab = mapData
    ? mapData.image && typeof mapData.image === "string"
      ? mapData.image
      : 1
    : 0;

  const tooltipID = "chronosMapForm";
  const tooltipIcon = "fas fa-question-circle fa-fw";

  const handleTabChange = () => {
    ReactTooltip.rebuild();
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{ minHeight: "100%" }}
      className="chronos-form"
    >
      <Tabs tabs={["General", "Settings"]} onTabChange={handleTabChange}>
        {/* General Tab */}
        <div>
          <div className="form-group">
            <label htmlFor="title" className="chronos-form-title">
              Title<sup className="required-flag">*</sup>
            </label>
            <Controller
              control={control}
              name="title"
              id="title"
              as="input"
              autoComplete="off"
              className="form-control"
              rules={{
                required: {
                  value: true,
                  message: "You must specify a title for this Map",
                },
                minLength: {
                  value: 3,
                  message: "The Map's title must be at least 3 characters long",
                },
              }}
            />

            <ErrorMessage
              errors={errors}
              name="title"
              render={({ message }) => <FormError message={message} />}
            />
          </div>
          <div className="form-group">
            <label htmlFor="description" className="chronos-form-title">
              Description
            </label>
            <Controller
              control={control}
              name="description"
              id="description"
              className="form-control"
              rows={5}
              as="textarea"
            />

            <ErrorMessage
              errors={errors}
              name="description"
              render={({ message }) => <FormError message={message} />}
            />
          </div>
          <div className="form-group">
            <label className="chronos-form-title">
              Map Image<sup className="required-flag">*</sup>
              &nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Choose the image for the new Map."
                data-for={tooltipID}
              />
            </label>
            <Tabs tabs={["New", "Existing"]} defaultTab={defaultImageTab}>
              <div className="form-group">
                {/* Select a New Image */}
                <Controller
                  control={control}
                  name="image.new"
                  render={({ onChange, value }) => (
                    <FileDropzone
                      onChange={(val) => handleSelectNewImage(onChange, val)}
                      value={value}
                      uploadMb={MAX_FILESIZE_MB}
                      className="chronos-file-dropzone"
                    />
                  )}
                />
              </div>
              <div className="form-group">
                {/* Select Existing Image */}
                <Controller
                  control={control}
                  name="image.existing"
                  render={({ onChange, value }) => (
                    <ImagePicker
                      value={value}
                      onChange={(val) =>
                        handleSelectExistingImage(onChange, val)
                      }
                      filters={["map"]}
                    />
                  )}
                />
              </div>
            </Tabs>
            {errors.image?.new && (
              <FormError message={errors.image.new.message} />
            )}
            {/* <ErrorMessage errors={errors} name="image.new" /> */}
          </div>
          <div className="form-group">
            <label htmlFor="title" className="chronos-form-title">
              Attribution Name&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Enter the name of the image owner or artist."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="attribution"
              id="attribution"
              as="input"
              autoComplete="off"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="title" className="chronos-form-title">
              Attribution Link&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Add a URL to link to the source or artist for the image."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="attributionLink"
              id="attributionLink"
              as="input"
              autoComplete="off"
              className="form-control"
            />
          </div>
        </div>
        {/* Settings Tab */}
        <div>
          <div className="form-group">
            <label className="chronos-form-title">
              Zoom Settings &nbsp;
              <Icon
                icon={tooltipIcon}
                data-for={tooltipID}
                data-tip={`Controls the limits that people can zoom in or out, as well as the initial desired zoom when this map is loaded.`}
              />
            </label>
            <ZoomControlsField
              min={-5}
              max={5}
              defaultValue={watch("options.zoomDefault")}
              defaultMin={watch("options.zoomMin")}
              defaultMax={watch("options.zoomMax")}
              setField={(key, val) => setValue(`options.${key}`, val)}
            />
          </div>
          {/* <div className="form-group">
            <label htmlFor="options.zoomDefault" className="chronos-form-title">
              Default Zoom Level&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="This controls the default zoom level when the Map is loaded. 0 means original size."
                data-for={tooltipID}
              />
              <span className="chronos-range-value">
                {watch("options.zoomDefault")}
              </span>
            </label>
            <br />
            <Controller
              control={control}
              name="options.zoomDefault"
              id="options.zoomDefault"
              // as={<input type="number" />}
              render={({ value, onChange }) => (
                <input
                  type="range"
                  min={watch("options.zoomMin")}
                  max={watch("options.zoomMax")}
                  value={value}
                  onChange={onChange}
                  style={{ width: "100%" }}
                />
              )}
              step={1}
              className="form-control"
            />
          </div>
          <div className="chronos-form-section-horizontal">
            <div className="form-group">
              <label htmlFor="options.zoomMin" className="chronos-form-title">
                Max Zoom Out&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This controls how far visitors can zoom out of the Map. Suggested to be between 0 and -3 (to be able to zoom out 3x)"
                  data-for={tooltipID}
                />
                <span className="chronos-range-value">
                  {watch("options.zoomMin")}
                </span>
              </label>
              <Controller
                control={control}
                name="options.zoomMin"
                id="options.zoomMin"
                // as={<input type="number" />}
                render={({ value, onChange }) => (
                  <input
                    type="range"
                    min={-5}
                    max={5}
                    value={value}
                    onChange={onChange}
                  />
                )}
                step={1}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="options.zoomMax" className="chronos-form-title">
                Max Zoom In&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This controls how far visitors can zoom into the Map. Suggested to be at least 3 (to be able to zoom in 3x) or higher."
                  data-for={tooltipID}
                />
                <span className="chronos-range-value">
                  {watch("options.zoomMax")}
                </span>
              </label>
              <Controller
                control={control}
                name="options.zoomMax"
                id="options.zoomMax"
                // as={<input type="number" />}
                render={({ value, onChange }) => (
                  <input
                    type="range"
                    min={-5}
                    max={5}
                    value={value}
                    onChange={onChange}
                  />
                )}
                step={1}
                className="form-control"
              />
            </div>
          </div> */}

          {/* <h4 className="form-section-title">Default Coordinates</h4> */}
          <div className="chronos-form-section-horizontal">
            <div className="form-group">
              <label htmlFor="options.coordX" className="chronos-form-title">
                X Coordinate&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This is the East/West coordinate for the default Map position."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="options.coordX"
                id="options.coordX"
                as={<input type="number" />}
                step={1}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="options.coordX" className="chronos-form-title">
                Y Coordinate&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="This is the North/South coordinate for the default Map position."
                  data-for={tooltipID}
                />
              </label>
              <Controller
                control={control}
                name="options.coordY"
                id="options.coordY"
                as={<input type="number" />}
                type="number"
                step={1}
                className="form-control"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="options.customClass" className="chronos-form-title">
              Custom CSS Class Name&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip="Assign a custom CSS class to this Map, allowing for more styling options."
                data-for={tooltipID}
              />
            </label>
            <Controller
              control={control}
              name="options.customClass"
              id="options.customClass"
              as="input"
              className="form-control"
              autoComplete="off"
            />
          </div>
          <div className="form-group">
            <label className="chronos-form-title chronos-custom-form-label">
              <span>
                Show Zoom Controls&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="Show or Hide the +/- zoom buttons (top right). Note: If this is disabled, visitors can still zoom in/out but they wont see the buttons."
                  data-for={tooltipID}
                />
              </span>
              <Controller
                control={control}
                name="options.showZoom"
                render={({ onChange, value }) => (
                  <Toggle
                    id="options.showZoom"
                    name="options.showZoom"
                    checked={value}
                    onChange={onChange}
                  />
                )}
              />
            </label>
          </div>
        </div>
        {/* Advanced */}
        {/* <div>
          <div className="form-group">
            <label className="chronos-form-title chronos-custom-form-label">
              <span>
                Show Attribution&nbsp;
                <Icon
                  icon={tooltipIcon}
                  data-tip="If the Map's artist or owner requires credit, this will display on the bottom right corner of the Map."
                  data-for={tooltipID}
                />
              </span>
              <Controller
                control={control}
                name="options.showAttribution"
                render={({ onChange, value }) => (
                  <Toggle
                    id="options.showAttribution"
                    name="options.showAttribution"
                    checked={value}
                    onChange={onChange}
                  />
                )}
              />
            </label>
          </div>
        </div> */}
      </Tabs>

      <div
        className="form-controls"
        style={{
          // position: 'absolute',
          // bottom: '1em',
          // width: '91.2%',
          width: "100%",
          marginTop: "1em",
          // marginBottom: '2em',
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {/* <Button color="secondary" type="button" onClick={handleCancel}>
          <Icon icon="fas fa-times fa-fw" />
          Cancel
        </Button> */}
        &nbsp;
        <Button color="primary" type="submit">
          <Icon icon="fas fa-save fa-fw" />
          {mapData && "Update"}
          {!mapData && "Create"}
        </Button>
      </div>
      <PaneLoader
        isNew={!(mapData && mapData._id)}
        text="Map"
        isLoading={isLoading}
      />
      <ReactTooltip effect="solid" id={tooltipID} />
      <DevTool control={control} />
    </form>
  );
}
